import {useTranslation} from '/provider/TranslationProvider';

export const useReleaseNotes = ({releaseNotes}: any) => {
  const {tt} = useTranslation('screen.releaseNotes');

  const parseReleaseNotes = JSON.parse(releaseNotes);

  return {tt, parseReleaseNotes};
};
